import baseURL from "../common/axios";
class Commonservices {
  creatStockOutMasterTM(data) {
    return baseURL.httpMSInventoryUrl.post("/StockOutMasterTM/Create", data);
  }
  createDraftStockOutMasterTM(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "/StockOutMasterTM/CreateDraft",
      data
    );
  }

  GetGRNReturnListByPoId(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockOutMasterTM/GRNReturnListByPoId?POId=" + data
    );
  }
  CreateConsumption(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "/StockOutMasterTM/CreateConsumption",
      data
    );
  }

  CreateBarcodeStockOut(data) {
    return baseURL.httpMSInventoryUrl.post(
      "/StockOutDetailsTD/CreateBarcodeStockOut",
      data
    );
  }
  updateStockOutMasterTM(data) {
    return baseURL.httpMSInventoryUrl.post("/StockOutMasterTM/Update", data);
  }
  // listStockOutMasterTM(
  //   startDate,
  //   endDate,
  //   PageSize,
  //   PageNum,
  //   docType,
  //   columnName,
  //   columnValue,
  //   columnName1,
  //   columnValue1
  // ) {
  //   return baseURL.httpMSInventoryUrl.get(
  //     "/StockOutMasterTM/List/StartDate/EndDate/PageNum/PageSize?startDate=" +
  //     startDate +
  //     "&endDate=" +
  //     endDate +
  //     "&pageSize=" +
  //     PageSize +
  //     "&pageNum=" +
  //     PageNum +
  //     "&DocType=" +
  //     docType +
  //     "&columnName=" +
  //     columnName +
  //     "&columnValue=" +
  //     columnValue +
  //     "&columnName1=" +
  //     columnName1 +
  //     "&columnValue1=" +
  //     columnValue1 +
  //     ""
  //   );
  // }

  listStockOutMasterTM(
    startDate,
    endDate,
    PageSize,
    PageNum,
    docType,
    columnName,
    columnValue,
    columnName1,
    columnValue1,
    columnName2,
    columnValue2,
    columnName3,
    columnValue3,
    columnName4,
    columnValue4,
    Flag,
    SearchOption,
    Condition
  ) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "/StockOutMasterTM/List/StartDate/EndDate/PageNum/PageSize?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&pageSize=" +
      PageSize +
      "&pageNum=" +
      PageNum +
      "&DocType=" +
      docType +
      "&columnName=" +
      columnName +
      "&columnValue=" +
      columnValue +
      "&columnName1=" +
      columnName1 +
      "&columnValue1=" +
      columnValue1 +
      "&columnName2=" +
      columnName2 +
      "&columnValue2=" +
      columnValue2 +
      "&columnName3=" +
      columnName3 +
      "&columnValue3=" +
      columnValue3 +
      "&columnName4=" +
      columnName4 +
      "&columnValue4=" +
      columnValue4 +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      "&Condition=" +
      Condition +
      ""
    );
  }
  createStockOutDetailsTD(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("/StockOutDetailsTD/Create", data);
  }
  UpdateBarcodeStockOutQty(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "/StockOutDetailsTD/UpdateBarcodeStockOutQty",
      data
    );
  }
  updateStockOutDetailsTD(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("/StockOutDetailsTD/Update", data);
  }
  DeleteStockOutTM(data) {
    return baseURL.httpMSInventoryUrl.delete(
      "StockOutMasterTM/Delete?Id=" + data
    );
  }
  DeleteStockOutDetailsTM(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete(
      "StockOutDetailsTD/Delete?Id=" + data
    );
  }
  GetById(Id) {
    return baseURL.httpMSInventoryUrl.get(
      "StockOutMasterTM/GetByStockOutId?id=" + Id + ""
    );
  }

  GetListByPIId(Id) {
    return baseURL.httpMSInventoryUrl.get(
      "StockOutMasterTM/GetListByPIId?Id=" + Id + ""
    );
  }

  //Stock In List based on Type
  GetStockInTMTableList(docType, StoreId) {
    return baseURL.httpMSInventoryUrl.get(
      "StockOutMasterTM/GetListByDocType?DocType=" +
      docType +
      "&StoreId=" +
      StoreId +
      ""
    );
  }
  GetListByDocNo(docType, StoreId, DocNo) {
    return baseURL.httpMSInventoryUrl.get(
      "StockOutMasterTM/GetListByDocNo?DocNo=" +
      DocNo +
      "&StoreId=" +
      StoreId +
      "&DocType=" +
      docType +
      ""
    );
  }
  GetListByDocNoCustom(DocNo, StoreId, docType) {
    return baseURL.httpMSInventoryUrl.get(
      "StockOutMasterTM/GetListByDocNoCustom?DocNo=" +
      DocNo +
      "&StoreId=" +
      StoreId +
      "&DocType=" +
      docType +
      ""
    );
  }
  updateGRNReturn(data) {
    return baseURL.httpMSInventoryUrl.post(
      "/StockOutMasterTM/UpdateGRNReturn",
      data
    );
  }

  creatStockOutMasterTMDraft(data) {
    return baseURL.httpMSInventoryUrl.post(
      "/StockOutMasterTM/CreateDraft",
      data
    );
  }

  UpdateCampIssueClose(StockOutId) {
    return baseURL.httpMSInventoryUrl.post(
      "StockOutMasterTM/UpdateCampIssueClose?StockOutId=" + StockOutId
    );
  }
}
export default new Commonservices();
